import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "worker-management" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "worker-table" }
const _hoisted_4 = { class: "worker-actions" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", null, [
      _cache[1] || (_cache[1] = _createElementVNode("div", null, [
        _createElementVNode("h2", null, "Worker 状态"),
        _createElementVNode("p", null, "单 Worker 本地队列，保留异常租约释放，不提供未接入的调度配置。")
      ], -1)),
      _createElementVNode("button", {
        type: "button",
        disabled: _ctx.loading,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.load && _ctx.load(...args)))
      }, "刷新状态", 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "worker-row worker-row--head" }, [
        _createElementVNode("span", null, "Worker"),
        _createElementVNode("span", null, "线路"),
        _createElementVNode("span", null, "状态"),
        _createElementVNode("span", null, "当前任务"),
        _createElementVNode("span", null, "最近活跃"),
        _createElementVNode("span", null, "操作")
      ], -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workers, (worker) => {
        return (_openBlock(), _createElementBlock("div", {
          key: worker.id,
          class: "worker-row"
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, _toDisplayString(worker.name), 1),
            _createElementVNode("small", null, _toDisplayString(worker.id), 1)
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.providerLabel(worker.provider)), 1),
          _createElementVNode("span", {
            class: _normalizeClass(['status-pill', _ctx.statusClass(worker)])
          }, _toDisplayString(_ctx.statusLabel(worker)), 3),
          _createElementVNode("span", null, _toDisplayString(worker.current_task_count) + " 个运行中", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.heartbeatText(worker)), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              title: "释放异常租约",
              onClick: ($event: any) => (_ctx.release(worker))
            }, "释放租约", 8, _hoisted_5)
          ])
        ]))
      }), 128)),
      (!_ctx.loading && _ctx.workers.length === 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, "尚未注册本地 Worker"))
        : _createCommentVNode("", true)
    ])
  ]))
}